module.exports = __webpack_public_path__ + "media/images/front/about/thumbnail9-50dffcccd8fadda7659e5337c8e35f03.jpg";